/**
 * Control JwPlayer video player to show video ad
 */
var VideoPlayer = /** @class */ (function () {
    /**
     * @constructor
     * @param player
     * @param {HTMLElement} div
     * @param {string} src
     */
    function VideoPlayer(player, div, src) {
        this.lastSrc = "";
        console.debug("create new instance of video player.");
        this.div = div;
        this.player = player;
        this.src = src;
    }
    /**
     * @func play
     * @desc change source of the video element and play ad
     */
    VideoPlayer.prototype.play = function () {
        var _this = this;
        console.debug("play ad video player.");
        this.player.controls(false);
        var video = this.getVideoElement();
        this.lastSrc = video.currentSrc;
        this.player.pause();
        setTimeout(function () {
            video.setAttribute("src", _this.src);
            video.pause();
            console.log(video.getAttribute("src"), { video: video });
            video.play();
        }, 1);
    };
    /**
     * @func skip
     * @desc skip ad
     * @param {boolean} replay
     */
    VideoPlayer.prototype.skip = function (replay) {
        console.debug("skip ad video player.", this.lastSrc);
        var video = this.getVideoElement();
        video.setAttribute("src", this.lastSrc);
        this.player.controls(true);
        if (replay) {
            video.pause();
            setTimeout(function () {
                video.currentTime = 0.1;
                video.play();
            }, 10);
        }
    };
    /**
     * @func getVideoElement
     * @desc get video element
     */
    VideoPlayer.prototype.getVideoElement = function () {
        var videoContainer = this.div.parentElement || document.createElement("div");
        return videoContainer.getElementsByTagName("video")[0];
    };
    return VideoPlayer;
}());
export default VideoPlayer;
//# sourceMappingURL=videoPlayer.js.map